import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "p-detail" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { class: "buttons" }

import { ProjectItem } from "@/services/entities/ProjectItem";
import { useOverviewStore } from "@/stores/overview";
import DxButton from 'devextreme-vue/button';

function formatDateToMonthYear(input: Date): string;
function formatDateToMonthYear(input: string): string | null;

export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectDetail',
  props: {
    project: { Type: {} as ProjectItem, default: {} as ProjectItem }
},
  emits: ['edit', 'delete'],
  setup(__props, { emit: __emit }) {

const overviewStore = useOverviewStore();
const emit = __emit;
const props = __props;

function formatDateToMonthYear(input: Date | string): string | null {
  let dateObject: Date;

  if (input instanceof Date) {
    dateObject = input;
  } else {
    // Try to parse the input string as a date
    const parsedDate = new Date(input);
    
    // Check if the parsed date is valid
    if (isNaN(parsedDate.getTime())) {
      // Return null for an invalid date string
      return null;
    }

    dateObject = parsedDate;
  }

  const month = dateObject.toLocaleString('default', { month: 'long' });
  const year = dateObject.getFullYear();
  const monthYearString = `${month} ${year}`;

  return monthYearString;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "title" }, "Project detail", -1)),
      _createVNode(_unref(DxButton), {
        icon: "trash",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('delete', props.project.id)))
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[3] || (_cache[3] = _createElementVNode("span", null, "Project type", -1)),
        _createElementVNode("span", null, _toDisplayString(_unref(overviewStore).getProjectTypes.find(a => a.id == props.project.projectTypeId)?.name), 1)
      ]),
      (props.project?.projectTypeId == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[4] || (_cache[4] = _createElementVNode("span", null, "Invoice type", -1)),
            _createElementVNode("span", null, _toDisplayString(_unref(overviewStore).getInvoiceType.find(a => a.id == props.project.invoiceTypeId)?.name), 1)
          ]))
        : _createCommentVNode("", true),
      (props.project?.projectTypeId == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _cache[5] || (_cache[5] = _createElementVNode("span", null, "Service", -1)),
            _createElementVNode("span", null, _toDisplayString(props.project?.service?.blServiceName), 1)
          ]))
        : _createCommentVNode("", true),
      (props.project?.projectTypeId == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _cache[6] || (_cache[6] = _createElementVNode("span", null, "Use checkbox", -1)),
            _createElementVNode("span", null, _toDisplayString((props.project?.isCheckbox ? "Yes" : "No")), 1)
          ]))
        : _createCommentVNode("", true),
      (props.project?.projectTypeId == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[7] || (_cache[7] = _createElementVNode("span", null, "Is custom activity", -1)),
            _createElementVNode("span", null, _toDisplayString((props.project?.isCustomActivity ? "Yes" : "No")), 1)
          ]))
        : _createCommentVNode("", true),
      (props.project?.projectTypeId == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _cache[8] || (_cache[8] = _createElementVNode("span", null, "Non-billable project type", -1)),
            _createElementVNode("span", null, _toDisplayString(_unref(overviewStore).getNonBillableProjectType.find(a => a.id == props.project.nonBillableProjectType)?.name), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _cache[9] || (_cache[9] = _createElementVNode("span", null, "Project name", -1)),
        _createElementVNode("span", null, _toDisplayString(props.project.projectName), 1)
      ]),
      _createElementVNode("div", null, [
        _cache[10] || (_cache[10] = _createElementVNode("span", null, "Project start", -1)),
        _createElementVNode("span", null, _toDisplayString(formatDateToMonthYear(props.project.projectStart)), 1)
      ]),
      _createElementVNode("div", null, [
        _cache[11] || (_cache[11] = _createElementVNode("span", null, "Project end", -1)),
        _createElementVNode("span", null, _toDisplayString(formatDateToMonthYear(props.project.projectEnd)), 1)
      ]),
      _createElementVNode("div", null, [
        _cache[12] || (_cache[12] = _createElementVNode("span", null, "Project number", -1)),
        _createElementVNode("span", null, _toDisplayString(props.project.projectNumber), 1)
      ]),
      _createElementVNode("div", null, [
        _cache[13] || (_cache[13] = _createElementVNode("span", null, "Responsible person", -1)),
        _createElementVNode("span", null, _toDisplayString(props.project.responsiblePerson), 1)
      ]),
      _createElementVNode("div", null, [
        _cache[14] || (_cache[14] = _createElementVNode("span", null, "Project manager", -1)),
        _createElementVNode("span", null, _toDisplayString(props.project.projectManager), 1)
      ]),
      _createElementVNode("div", null, [
        _cache[15] || (_cache[15] = _createElementVNode("span", null, "Description", -1)),
        _createElementVNode("span", null, _toDisplayString(props.project.description), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('edit', props.project.id))),
        class: "accent"
      }, "Edit")
    ])
  ]))
}
}

})